/* eslint-disable jsx-a11y/control-has-associated-label */
import CloseIcon from '@mui/icons-material/Close';
import Modal from 'react-modal';
import { IBranchViewModel } from 'viewModels';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/IconDelete.svg';
import { CompanyController } from '../../../controller/CompanyController';
import { Button } from '../../Buttons/Button';
import { ContentModal, Header } from './style';

interface ModalDeleteBranchProps {
  isOpen: boolean;
  currentBranch: IBranchViewModel;
  runningTutorial: boolean;
  onRequestClose: () => void;
  onRequestRemoveBranch: () => void;
}

export function ModalDeleteBranch({
  isOpen,
  currentBranch,
  onRequestClose,
  runningTutorial,
  onRequestRemoveBranch,
}: ModalDeleteBranchProps) {
  const handleDeleteBranch = () => {
    if (!runningTutorial) {
      CompanyController.deleteBranch(currentBranch.id);
    }

    onRequestRemoveBranch();
    onRequestClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-delete-modal-content">
      <Header>
        <div className="subHeader">
          <DeleteIcon className="deleteIcon" />
          <h1>Exclusão</h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={onRequestClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>
      <ContentModal>
        <h2 className="confirmationText">Tem certeza que quer excluir a filial</h2>
        <p>{currentBranch.name}</p>
        <div className="buttonModal">
          <Button
            text="Cancelar"
            dimensions={{ width: '13rem', height: '2.25rem' }}
            onClick={onRequestClose}
          />
          <Button
            text="Excluir"
            dimensions={{ width: '13rem', height: '2.25rem' }}
            onClick={handleDeleteBranch}
          />
        </div>
      </ContentModal>
    </Modal>
  );
}
